<template>
    <div class="message-wrapper bot">
        <div class="message-bubble bot thinking">
            <div class="typing-indicator">
                <span />
                <span />
                <span />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.message-wrapper {
    display: flex;
    animation: slide-in 0.3s ease-out;
    margin-block-end: var(--spacing-03);
}

.message-wrapper.bot {
    justify-content: flex-start;
}

.message-bubble {
    border-radius: var(--border-radius-md);
    box-shadow: 0 1px 2px rgb(0 0 0 / 0.1);
    max-inline-size: var(--chat-message-max-width);
    padding-block: var(--spacing-3x);
    padding-inline: var(--spacing-03);
}

.message-bubble.bot {
    background: var(--background-secondary);
    border-end-start-radius: var(--border-radius-sm);
    color: var(--text-primary);
}

.message-bubble.thinking {
    padding-block: var(--spacing-03);
    padding-inline: var(--spacing-05);
}

.typing-indicator {
    display: flex;
    align-items: center;
    block-size: var(--spacing-05);
    gap: var(--spacing-01);
}

.typing-indicator span {
    display: block;
    border-radius: var(--border-radius-circle);
    animation: typing 1.4s infinite;
    background-color: var(--text-tertiary);
    block-size: var(--size-0);
    inline-size: var(--size-0);
}

.typing-indicator span:nth-child(1) {
    animation-delay: 0s;
}

.typing-indicator span:nth-child(2) {
    animation-delay: 0.2s;
}

.typing-indicator span:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes typing {
    0%,
    60%,
    100% {
        opacity: 0.4;
        transform: translateY(0);
    }

    30% {
        opacity: 1;
        transform: translateY(-10px);
    }
}

@keyframes slide-in {
    from {
        opacity: 0;
        transform: translateY(var(--spacing-02));
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
